module.exports = __webpack_public_path__ + "img/ManagementAdmin.2e697eee.svg";